import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Chip,
  styled,
  Checkbox,
  ListItemText,
  Grid,
  Typography,
  Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

// utils
import { bgBlur } from '../../utils/cssStyles';

import { CommonIcons, icons } from '../../components/common/CommonIcons';
//
// import Searchbar from './Searchbar';
// import AccountPopover from './AccountPopover';
// import LanguagePopover from './LanguagePopover';
// import NotificationsPopover from './NotificationsPopover';

import { useAuthAccess } from '../../hooks/useAuthAccess';
import { useAppContextFeatures } from '../../context/AppContext';

import MenuAccount from './MenuAccount';

import CommonTranslation from '../../components/common/CommonTranslation';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 80;// 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  // [theme.breakpoints.up('lg')]: {
  //   width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  // },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  // [theme.breakpoints.up('lg')]: {
  //   minHeight: HEADER_DESKTOP,
  //   padding: theme.spacing(0, 5),
  // },
}));

// ----------------------------------------------------------------------

Menu.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Menu({ onOpenNav, navMinimize, t }) {

  const { getAvailableLocations } = useAuthAccess()

  const theme = useTheme();
  const [locations, setLocations] = useState(getAvailableLocations())
  const { getLocationIds, setLocationIds } = useAppContextFeatures();
  // const [ selectedLocations, setSelectedLocations ] = useState([])

  // set default all locations based on login
  useEffect(() => {

    if (locations && locations.length) {
      const defaultLocationIds = locations.map(i => i.id);
      // console.log('defaultLocationIds', defaultLocationIds)
      setLocationIds(defaultLocationIds)
    }


  }, [locations])

  // console.log('locations', locations)

  // function getStyles(name, personName, theme) {
  //   return {
  //     fontWeight:
  //       personName.indexOf(name) === -1
  //         ? theme.typography.fontWeightRegular
  //         : theme.typography.fontWeightMedium,
  //   };
  // }

  const RenderLocationSelection = () => {

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      setLocationIds(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };

    return (
      <Box
        sx={{
          // ml: 1,
          mr: 2,
          // minWidth: '100'
          width: '100%',
        }}
      >
        <FormControl fullWidth sx={{}} size='small'>
          <InputLabel>
            {t("locations")}
          </InputLabel>
          <Select
            labelId={t("locations")}
            id={t("locations")}
            multiple
            value={getLocationIds()}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            renderValue={(selected) => (
              // <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              //   {selected.map((value) => (
              //     <Chip key={value} label={value} />
              //   ))}
              // </Box>
              <Typography>
                {
                  selected ? selected.length : '-'
                } {t("locations")}
              </Typography>
            )}
            MenuProps={MenuProps}
          >
            {locations && locations.map((item, index) => (
              <MenuItem key={index} value={item?.id}>
                <Checkbox
                  checked={getLocationIds().indexOf(item.id) > -1}
                />
                <ListItemText
                  primary={item?.location_name}
                  secondary={item?.state_name}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    )
  }


  return (
    <StyledRoot
      sx={{
        width: navMinimize ? '100%' : `calc(100% - ${NAV_WIDTH + 1}px)`,
        // backgroundColor: 'yellow'
      }}
    >
      <StyledToolbar
        sx={{
          minHeight: navMinimize ? 'auto' : HEADER_DESKTOP,
          padding: navMinimize ? 'auto' : theme.spacing(0, 5),
        }}
      >
        <Stack
          // display={"flex"}
          // flexDirection="row"
          // justifyContent={"space-between"}
          // alignItems="center"
          spacing={{
            // xs: 0.5,
            // sm: 1,
          }}
          sx={{
            // backgroundColor: 'red',
            // flex: 1
            p: 0.5
          }}
          flexGrow={1}
        >
          {/* {JSON.stringify(getLocationIds())} */}
          <Grid container alignItems="center" direction="row" spacing={0}>
            <Grid item xs={3} sm={3} md={6}>
              <Box
                sx={{
                  flex: 1,
                }}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
              >
                <IconButton
                  onClick={onOpenNav}
                  sx={{
                    // mr: 1,
                    p: 0,
                    width: 45,
                    height: 45,
                    color: 'text.primary',
                    // display: { lg: 'none' },
                    display: navMinimize ? 'block' : 'none'
                  }}
                >
                  <CommonIcons name={icons.burger} sx={{ width: 40, height: 40 }} />
                </IconButton>

                {/* <Button
                  variant={"outlined"}
                  sx={{
                    ml: navMinimize? 2 : 0
                  }}
                  // size='small'
                >
                  <CommonIcons name={icons.chevronLeft} />
                  Back
                </Button> */}

              </Box>
            </Grid>
            <Grid item xs={9} sm={9} md={6}>
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                sx={{
                  // flex: 1,
                  // backgroundColor: 'green',
                  // alignSelf: 'flex-end'
                }}
                textAlign={"right"}
              >
                {
                  RenderLocationSelection()
                }
                <Box
                  sx={{
                    mr: 0
                  }}
                >
                  <CommonTranslation />
                </Box>
                <MenuAccount
                  t={t}
                />
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
